/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnectionSalesTypes from './receive-connection-sales-types';

export default (connectionId) => (dispatch) => {
    dispatch({
        type: actions.CONNECTION_SALES_TYPES_REQUEST,
    });

    return cecSdk
        .connectionSalesTypes(connectionId)
        .getConnectionSalesTypes()
        .then((connectionSalesTypes) => {
            dispatch({
                type: actions.CONNECTION_SALES_TYPES_REQUEST_SUCCESS,
            });
            
            dispatch(receiveConnectionSalesTypes(connectionSalesTypes));
            return connectionSalesTypes;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTION_SALES_TYPES_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
